(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rcl-fabric-swatches"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('#rcl-swatch-form').forEach(form=>{
form.addEventListener('change',event=>{
if(event.target.name!=='id')return;
form.querySelector('[data-sw-selected]').textContent=event.target.dataset.name;
form.querySelector('button[name="add"]').disabled=false;
if(window.matchMedia('(max-width:800px)').matches)form.querySelector('.sw-summary').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'center'});
const url=new URL(window.location.href);url.searchParams.set('variant',event.target.value);history.replaceState({},'',url);
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rcl-home-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.rclProductPreviewVersion === 2) return;
  window.rclProductPreviewVersion = 2;
  const requests = new WeakMap();
  const cache = new Map();
  function source(button) {
    const image = button.closest('.rh-story').querySelector('.rh-product-image');
    const url = new URL(button.dataset.previewImage, location.href);
    const width = Math.max(480, Math.min(1200, Math.ceil(image.clientWidth * Math.min(window.devicePixelRatio || 1, 2) / 160) * 160));
    url.searchParams.set('width', width);
    return url.href;
  }
  function preload(src) {
    if (!cache.has(src)) {
      cache.set(src, new Promise((resolve, reject) => {
        const image = new Image();
        let finished = false;
        const done = (error) => {
          if (finished) return;
          finished = true;
          clearTimeout(timer);
          image.onload = image.onerror = null;
          if (error) {
            cache.delete(src);
            reject(error);
          } else resolve(image);
        };
        const timer = setTimeout(() => done(new Error('Image timed out')), 15000);
        image.onload = () => done();
        image.onerror = () => done(new Error('Image unavailable'));
        image.src = src;
        if (image.complete && image.naturalWidth) done();
      }));
    }
    return cache.get(src);
  }
  function choiceFrom(event) {
    return event.target instanceof Element ? event.target.closest('[data-preview-choice]') : null;
  }
  function warm(event) {
    const button = choiceFrom(event);
    if (button) preload(source(button)).catch(() => {});
  }
  window.addEventListener('pointerover', warm, true);
  window.addEventListener('focusin', warm, true);
  window.addEventListener('click', async event => {
    const button = choiceFrom(event);
    if (!button) return;
    event.preventDefault();
    const section = button.closest('.rh-story');
    const photo = section.querySelector('.rh-product-image');
    const panel = section.querySelector('[data-preview-panel]');
    const status = section.querySelector('[data-preview-status]');
    const request = {};
    const src = source(button);
    requests.set(section, request);
    section.querySelectorAll('[data-preview-choice]').forEach(choice => {
      choice.setAttribute('aria-pressed', String(choice === button));
    });
    section.querySelector('[data-preview-caption]').textContent = button.dataset.previewCaption;
    const link = section.querySelector('[data-preview-shop]');
    link.href = button.dataset.previewUrl;
    link.textContent = button.dataset.previewShopLabel;
    if (button.dataset.previewSofaUrl) {
      const sofaLink = section.querySelector('.rh-actions .rh-link');
      if (sofaLink) sofaLink.href = button.dataset.previewSofaUrl;
    }
    panel.setAttribute('aria-busy', 'true');
    panel.removeAttribute('data-preview-error');
    status.textContent = 'Loading ' + button.textContent.trim() + ' photo…';
    try {
      await preload(src);
      if (requests.get(section) !== request) return;
      photo.removeAttribute('srcset');
      photo.removeAttribute('data-srcset');
      photo.removeAttribute('data-src');
      photo.src = src;
      photo.alt = button.dataset.previewAlt;
      status.textContent = '';
    } catch (_) {
      if (requests.get(section) !== request) return;
      panel.setAttribute('data-preview-error', 'true');
      status.textContent = 'Photo didn’t load. Tap your choice to try again.';
    } finally {
      if (requests.get(section) === request) panel.removeAttribute('aria-busy');
    }
  }, true);
  if ('IntersectionObserver' in window) {
    const observed = new WeakSet();
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        entry.target.querySelectorAll('[data-preview-choice]').forEach(button => {
          preload(source(button)).catch(() => {});
        });
      });
    }, { rootMargin: '200px' });
    const observe = () => document.querySelectorAll('[data-preview-panel]').forEach(panel => {
      if (!observed.has(panel)) {
        observed.add(panel);
        observer.observe(panel);
      }
    });
    observe();
    document.addEventListener('shopify:section:load', observe);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rcl-showroom"] && !Shopify.designMode) return;
  try {
    
(function(){
 function initShowroomScroll(){
  var target=document.getElementById('rcl-showroom');
  if(!target||target.dataset.rclScrollReady)return;
  target.dataset.rclScrollReady='true';
  var header=document.getElementById('header-outer');
  var nav=document.getElementById('nav-outer');
  function visibleHeaderBottom(){
    var bottom=0;
    var mobile=window.matchMedia('(max-width:1000px)').matches;
    var candidates=mobile?[document.getElementById('header'),header]:[header,nav];
    candidates.forEach(function(element){
      if(!element)return;
      var rect=element.getBoundingClientRect();
      var style=getComputedStyle(element);
      if(style.display==='none'||style.visibility==='hidden'||rect.height===0)return;
      var pinned=false;
      for(var parent=element;parent&&parent!==document.body;parent=parent.parentElement){
        var position=getComputedStyle(parent).position;
        if(position==='fixed'||position==='sticky'||parent.classList.contains('fixed')){pinned=true;break;}
      }
      if(pinned&&rect.top<window.innerHeight/2&&rect.bottom>0&&rect.bottom<window.innerHeight/2){
        bottom=Math.max(bottom,rect.bottom);
      }
    });
    return bottom+(mobile&&bottom>0?4:0);
  }
  function updateOffset(){
    target.style.setProperty('--rcl-showroom-header-offset',visibleHeaderBottom()+'px');
  }
  var frame=0;
  var activeUntil=0;
  var correctionTimer=0;
  var scrollStyle=document.documentElement.style;
  var previousScrollBehavior=scrollStyle.scrollBehavior;
  function restoreScrollBehavior(){scrollStyle.scrollBehavior=previousScrollBehavior;}
  function destination(){
    return Math.max(0,window.scrollY+target.getBoundingClientRect().top-visibleHeaderBottom());
  }
  function go(){
    cancelAnimationFrame(frame);
    clearTimeout(correctionTimer);
    previousScrollBehavior=frame?previousScrollBehavior:scrollStyle.scrollBehavior;
    scrollStyle.scrollBehavior='auto';
    var startY=window.scrollY;
    var started=performance.now();
    var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var duration=reduced?0:Math.min(1100,Math.max(550,Math.abs(destination()-startY)*0.35));
    activeUntil=Date.now()+5000;
    function step(now){
      var progress=duration?Math.min(1,(now-started)/duration):1;
      var eased=1-Math.pow(1-progress,3);
      window.scrollTo(0,startY+(destination()-startY)*eased);
      if(progress<1)frame=requestAnimationFrame(step);
      else {
        frame=0;restoreScrollBehavior();
        correctionTimer=setTimeout(function(){
          if(Date.now()<activeUntil&&Math.abs(destination()-window.scrollY)>2){
            scrollStyle.scrollBehavior='auto';window.scrollTo(0,destination());restoreScrollBehavior();
          }
        },300);
      }
    }
    frame=requestAnimationFrame(step);
  }
  function cancel(){
    cancelAnimationFrame(frame);frame=0;activeUntil=0;clearTimeout(correctionTimer);restoreScrollBehavior();
  }
  ['wheel','touchstart','pointerdown','keydown'].forEach(function(name){window.addEventListener(name,cancel,{passive:true});});
  window.addEventListener('click',function(event){
    var link=event.target instanceof Element?event.target.closest('a[href]'):null;
    if(!link||(typeof event.button==='number'&&event.button!==0)||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||link.target==='_blank')return;
    var url=new URL(link.href,location.href);
    if(url.origin!==location.origin||url.pathname!==location.pathname||url.hash!=='#rcl-showroom')return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if(location.hash!=='#rcl-showroom')history.pushState(null,'','#rcl-showroom');
    go();
  },true);
  window.addEventListener('hashchange',function(){if(location.hash==='#rcl-showroom')go();});
  window.addEventListener('load',function(){if(location.hash==='#rcl-showroom')go();},{once:true});
  if(window.ResizeObserver){
    new ResizeObserver(function(){
      updateOffset();
      if(frame||Date.now()>activeUntil)return;
      clearTimeout(correctionTimer);
      correctionTimer=setTimeout(function(){if(Date.now()<activeUntil&&Math.abs(destination()-window.scrollY)>2)go();},150);
    }).observe(document.body);
  }
  updateOffset();
  if(document.readyState==='complete'&&location.hash==='#rcl-showroom')go();

 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initShowroomScroll,{once:true});
 else initShowroomScroll();
 document.addEventListener('shopify:section:load',initShowroomScroll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rcl-site-footer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.rcl-site-footer').forEach(function (footer) {
    new IntersectionObserver(function (entries) {
      document.body.classList.toggle('rcl-footer-visible', entries[0].isIntersecting);
    }, { rootMargin: '120px 0px' }).observe(footer);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rcl-stock-groups"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const list = root.querySelector('[data-stock-group-list]');
    const back = root.querySelector('[data-stock-back]');
    const selectedType = () => {
      if (!location.hash.startsWith('#category=')) return null;
      try { return decodeURIComponent(location.hash.slice(10)); } catch { return null; }
    };
    const navigate = () => {
      const selected = selectedType();
      back.hidden = selected === null;
      [...list.children].forEach(group => {
        group.hidden = selected !== null && group.dataset.type !== selected;
        group.open = selected !== null && group.dataset.type === selected;
      });
    };
    window.addEventListener('hashchange', navigate);
    window.addEventListener('popstate', navigate);
    const recount = () => {
      list.querySelectorAll('.rcl-stock-group').forEach(group => {
        group.querySelector('[data-group-count]').textContent = group.querySelectorAll('[data-product-id]').length;
      });
      [...list.children].sort((a,b) => a.dataset.type.localeCompare(b.dataset.type)).forEach(group => list.append(group));
    };
    const merge = incoming => {
      incoming.querySelectorAll('.rcl-stock-group').forEach(group => {
        const existing = [...list.children].find(g => g.dataset.type === group.dataset.type);
        if (!existing) { list.append(group); return; }
        const grid = existing.querySelector('.rcl-stock-group-grid');
        group.querySelectorAll('[data-product-id]').forEach(card => {
          if (![...grid.children].some(c => c.dataset.productId === card.dataset.productId)) grid.append(card);
        });
      });
      recount();
      navigate();
    };
    let busy = false;
    const load = async () => {
      if (busy) return;
      busy = true;
      let next = root.querySelector('[data-stock-next]');
      try {
        while (next) {
          const url = new URL(next.href);
          url.searchParams.set('section_id', root.dataset.section);
          const response = await fetch(url);
          if (!response.ok) throw new Error('Unable to load');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = doc.querySelector('[data-stock-groups]');
          if (!incoming) throw new Error('Missing product groups');
          merge(incoming);
          const following = incoming.querySelector('[data-stock-next]');
          if (following) { next.href = following.href; } else { next.remove(); next = null; }
        }
      } catch (error) {
        if (next) next.hidden = false;
      } finally { busy = false; }
    };
    root.addEventListener('click', event => {
      const summary = event.target.closest('.rcl-stock-group > summary');
      if (summary) {
        event.preventDefault();
        location.hash = 'category=' + encodeURIComponent(summary.parentElement.dataset.type);
        navigate();
        back.focus();
      }
      if (event.target.closest('[data-stock-back]')) {
        event.preventDefault();
        history.pushState(null, '', location.pathname + location.search);
        navigate();
        list.querySelector('summary')?.focus();
      }
      if (event.target.closest('[data-stock-next]')) { event.preventDefault(); load(); }
    });
    recount();
    navigate();
    load();
  };
  document.querySelectorAll('[data-stock-groups]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-stock-groups]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
